<template>
  <Grid
    hasGap
  >
    <GridItem :gridSpan="4">
      <HeadingSmall :hasMargin="false">
        Name
      </HeadingSmall>
      <ParagraphBody>
        {{ userName }}
        <PasswordManagerUserStatus
          class="passwordManagerUserStatus"
          :status="item.status"
        />
      </ParagraphBody>
    </GridItem>
    <GridItem :gridSpan="4">
      <HeadingSmall :hasMargin="false">
        Items Count
      </HeadingSmall>
      <ParagraphBody>
        {{ item.itemsCount }}
      </ParagraphBody>
    </GridItem>
    <GridItem :gridSpan="4">
      <HeadingSmall :hasMargin="false">
        Date Created
      </HeadingSmall>
      <ParagraphBody>
        {{ formattedDateCreated }}
      </ParagraphBody>
    </GridItem>
    <GridItem :gridSpan="4">
      <HeadingSmall :hasMargin="false">
        Email
      </HeadingSmall>
      <ParagraphBody>
        {{ item.email }}
      </ParagraphBody>
    </GridItem>
    <GridItem :gridSpan="4">
      <HeadingSmall :hasMargin="false">
        Password Health
      </HeadingSmall>
      <ParagraphBody>
        <PasswordManagerPasswordScoreStatus
          :hasPasswords="hasPasswords"
          :passwordScore="item.passwordsScore"
          :scoreUpdatedAt="item.scoreUpdatedAt"
        />
      </ParagraphBody>
    </GridItem>
  </Grid>
</template>

<script>
import {
  Grid,
  GridItem,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import DateUtil from 'client/util/DateUtil';
import PasswordManagerPasswordScoreStatus from 'client/PasswordManager/components/PasswordManagerPasswordScoreStatus.vue';
import PasswordManagerUserStatus from 'client/PasswordManager/Users/PasswordManagerUserStatus.vue';

export default {
  name: 'PasswordManagerUserInfo',

  components: {
    Grid,
    GridItem,
    HeadingSmall,
    ParagraphBody,
    PasswordManagerPasswordScoreStatus,
    PasswordManagerUserStatus,
  },

  props: {
    item: {
      required: true,
      type: Object,
    },
  },

  computed: {
    formattedDateCreated() {
      return DateUtil.formatDateTime(this.item.createdAt);
    },

    hasPasswords() {
      return !!this.item.passwordsCount;
    },

    userName() {
      return this.item?.name?.trim() || '-';
    },
  },
};
</script>

<style scoped>
.passwordManagerUserStatus {
  vertical-align: middle;
}
</style>
